import { ComponentPropsWithRef } from 'react';
import {
  // eslint-disable-next-line @typescript-eslint/no-restricted-imports
  Link as RRLink,
  // eslint-disable-next-line @typescript-eslint/no-restricted-imports
  NavLink as RRNavLink,
} from 'react-router';
import { useHasNewAppVersion } from '@/components/app-version-updater/has-new-app-version';

export type { LinkProps, NavLinkProps } from 'react-router';

export const Link = function Link({
  ref,
  ...props
}: ComponentPropsWithRef<typeof RRLink>) {
  const hasNewAppVersion = useHasNewAppVersion();

  return <RRLink ref={ref} reloadDocument={hasNewAppVersion} {...props} />;
};

export const NavLink = function Link({
  ref,
  ...props
}: ComponentPropsWithRef<typeof RRNavLink>) {
  const hasNewAppVersion = useHasNewAppVersion();

  return <RRNavLink ref={ref} reloadDocument={hasNewAppVersion} {...props} />;
};
